module.exports = __webpack_public_path__ + "static/media/FD6.1a23a1d6.png";